import BenefitDetails from './BenefitDetails'

export default BenefitDetails
